<template>
	<ui-popover trigger="clickToOpen" placement="right" :class="{disabled}" :disabled="disabled">
		<template #target>
			<ui-button class="primary md block">
				<i class="fal fa-clock"></i>
				{{ time.start + " às " + time.end }}
			</ui-button>
		</template>

		<template #content>
			<div class="ui-popover-select-time">
				<div class="title">{{ label }}</div>

				<form class="inputs" @submit.prevent="submit">
					<input
						v-model="time.start"
						:max="tStartMax"
						min="00:00"
						class="input"
						type="time"
						ref="start"
					/>
					<input
						v-model="time.end"
						:min="tEndMin"
						max="23:59"
						class="input"
						type="time"
						ref="end"
					/>
					<button class="button-submit" type="submit">
						<i class="fal fa-check"></i>
					</button>
				</form>
			</div>
		</template>
	</ui-popover>
</template>

<script>
	import { uiPopover } from "@/components/ui"
	import { uiButton } from "@/components/ui/buttons"

	export default {
		props: {
			/**
			 * Atribui o a hora Inicial ao componente
			 */
			start: {
				required: true,
				type: String,
				default: "",
			},

			/**
			 * Atribui o a hora Final ao componente
			 */
			end: {
				required: true,
				type: String,
				default: "",
			},

			/**
			 * Define a label/título a ser mostrado no componente
			 */
			label: {
				required: false,
				type: String,
				default: "Definir horário",
			},

			/**
			 * Define o estado desativo do popover
			 * apenas mostra os conteudos iniciais e desativa o trigger
			 */
			disabled: {
				type: Boolean,
				default: false,
			},
		},

		components: {
			uiPopover,
			uiButton,
		},

		data() {
			return {
				time: {
					start: this.start || 0,
					end: this.end || 0,
				},
			}
		},

		methods: {
			submit() {
				this.time.start = this.$refs.start.value
				this.time.end = this.$refs.end.value

				this.$emit("change", this.time)

				/**
				 * Acessa o 'filho' que é o componente POPPER para executar
				 * o método 'close'.
				 */
				this.$children[0].$children[0].doClose()
			},
		},

		computed: {
			/**
			 * Computed property que retorna o horário máximo de início, de acordo
			 * com o horário de fim cadastrado
			 */
			tStartMax() {
				let max = '23:58'
				if (this.time.end) {
					const hour = this.time.end.split(':')[0]
					const minutes = this.time.end.split(':')[1]
					max = `${hour}:${parseInt(minutes)-1}`
				}

				return max
			},
			/**
			 * Computed property que retorna o horário mínimo de fim, de acordo
			 * com o horário de início cadastrado
			 */
			tEndMin() {
				let min = '00:01'
				if (this.start) {
					const hour = this.time.start.split(':')[0]
					const minutes = this.time.start.split(':')[1]
					min = `${hour}:${parseInt(minutes)+1}`
				}

				return min
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
